import React from "react";
import { ModalProps } from "antd";
import { Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const CommonModal: React.FC<ModalProps> = ({className, ...rest }) => {
  return (
    <Modal
      centered
      className={"common_modal "+className}
      closeIcon={<FontAwesomeIcon icon={faTimes}  />}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
      footer={null}
     {...rest}
    />
  );
};

export default CommonModal;
